import { useCallback } from 'react'

import { resetCrudSelection } from '@/atoms'

import { useDeleteDriverAssignmentModal } from '../../../../../modals/DeleteDriverAssignmentModal'

export function useActions() {
  const { show: showDeleteDriverAssignmentModal } = useDeleteDriverAssignmentModal()

  const onDelete = useCallback(() => {
    showDeleteDriverAssignmentModal()
  }, [showDeleteDriverAssignmentModal])

  const onReset = useCallback(() => {
    resetCrudSelection('driverAssignments')
  }, [])

  return {
    onDelete,
    onReset,
  }
}
